<template>
  <div class="container my-5 py-3" id="galeria">
    <!-- Encabezado de la Galería -->
    <div class="row mb-4">
      <div class="col-12 text-center">
        <p class="fs-1 naranjaFit roboto fw-bold mb-1">NUESTRA GALERÍA</p>
        <p class="quicksand fs-5 colorLetras">
          Conoce nuestros platillos preparados frescos todos los días
        </p>
      </div>
    </div>

    <!-- Carrusel de Fotos Nativas -->
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-8">
        <div id="galeriaFitbarCarousel" class="carousel slide shadow-lg rounded-4 overflow-hidden" data-bs-ride="carousel">
          <!-- Indicadores -->
          <div class="carousel-indicators">
            <button
              v-for="(foto, index) in fotosGaleria"
              :key="'indicator-' + index"
              type="button"
              data-bs-target="#galeriaFitbarCarousel"
              :data-bs-slide-to="index"
              :class="{ active: index === 0 }"
              :aria-current="index === 0 ? 'true' : undefined"
              :aria-label="'Slide ' + (index + 1)"
            ></button>
          </div>

          <!-- Slides -->
          <div class="carousel-inner">
            <div
              v-for="(foto, index) in fotosGaleria"
              :key="'slide-' + index"
              class="carousel-item"
              :class="{ active: index === 0 }"
              data-bs-interval="4000"
            >
              <div class="galeria-img-container position-relative">
                <img :src="foto.img" class="d-block w-100 galeria-img" :alt="foto.titulo" />
                <div class="galeria-caption">
                  <h5 class="fw-bold roboto mb-1">{{ foto.titulo }}</h5>
                  <p class="mb-0 small quicksand">{{ foto.categoria }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Controles Anterior / Siguiente -->
          <button class="carousel-control-prev" type="button" data-bs-target="#galeriaFitbarCarousel" data-bs-slide="prev">
            <span class="carousel-control-prev-icon p-3 bg-dark bg-opacity-50 rounded-circle" aria-hidden="true"></span>
            <span class="visually-hidden">Anterior</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#galeriaFitbarCarousel" data-bs-slide="next">
            <span class="carousel-control-next-icon p-3 bg-dark bg-opacity-50 rounded-circle" aria-hidden="true"></span>
            <span class="visually-hidden">Siguiente</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Enlaces Sociales -->
    <div class="row mt-4">
      <div class="col-12 text-center">
        <p class="quicksand colorLetras mb-3">Síguenos en nuestras redes sociales y comparte tu experiencia:</p>
        <div class="d-flex justify-content-center gap-3 flex-wrap">
          <a
            href="https://www.facebook.com/fitbarcancun"
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn-red-social btn-facebook px-4 py-2"
          >
            <img :src="require('@/assets/img/facebook.png')" alt="Facebook" width="22" class="me-2" />
            Facebook @fitbarcancun
          </a>
          <a
            href="https://www.instagram.com/thefitbarcancun/"
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn-red-social btn-instagram px-4 py-2"
          >
            <img :src="require('@/assets/img/instagram.png')" alt="Instagram" width="22" class="me-2" />
            Instagram @thefitbarcancun
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Galeria",
  data() {
    return {
      fotosGaleria: [
        {
          titulo: "Top Sirloin a la Parrilla",
          categoria: "Platos Fuertes",
          img: require("@/assets/img/galeria/PLATO_FUERTE_TOP_SIRLOIN.png"),
        },
        {
          titulo: "Matcha Fit Cakes",
          categoria: "Hot Cakes Saludables",
          img: require("@/assets/img/galeria/HOTCAKES_MATCHA_FIT_CAKES.png"),
        },
        {
          titulo: "Avena Imperial con Frutos Rojos",
          categoria: "Bowls & Avenas",
          img: require("@/assets/img/galeria/AVENA_IMPERIAL.png"),
        },
        {
          titulo: "Ensalada Fresona",
          categoria: "Ensaladas Frescas",
          img: require("@/assets/img/galeria/ENSALADA_FRESONA.png"),
        },
        {
          titulo: "Batido de Proteína",
          categoria: "Bebidas Fitness",
          img: require("@/assets/img/galeria/BEBIDA_BATIDO_DE_PROTEÍNA.png"),
        },
        {
          titulo: "Sándwich Verde con Aguacate",
          categoria: "Sándwiches Integrales",
          img: require("@/assets/img/galeria/SÁNDWICH_VERDE.png"),
        },
        {
          titulo: "Omelette de Champiñones con Queso Panela",
          categoria: "Desayunos Saludables",
          img: require("@/assets/img/galeria/OMELETTE_DE_CHAMPIÑONES_CON_QUESO.png"),
        },
      ],
    };
  },
};
</script>

<style scoped>
.galeria-img-container {
  height: 480px;
  background-color: #1a1a1a;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.galeria-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.galeria-img-container:hover .galeria-img {
  transform: scale(1.03);
}

.galeria-caption {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 1.5rem;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.75) 100%);
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.btn-red-social {
  display: inline-flex;
  align-items: center;
  font-weight: 600;
  border-radius: 30px;
  text-decoration: none !important;
  transition: all 0.3s ease;
  padding: 0.6rem 1.4rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.btn-facebook {
  background-color: #ffffff;
  color: #1877f2 !important;
  box-shadow: 0 4px 14px rgba(24, 119, 242, 0.15);
}

.btn-facebook:hover {
  background-color: #1877f2;
  color: #ffffff !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(24, 119, 242, 0.3);
}

.btn-instagram {
  background-color: #ffffff;
  color: #e1306c !important;
  box-shadow: 0 4px 14px rgba(225, 48, 108, 0.15);
}

.btn-instagram:hover {
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
  color: #ffffff !important;
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(225, 48, 108, 0.3);
}

@media (max-width: 768px) {
  .galeria-img-container {
    height: 320px;
  }
}
</style>